import React, { Component } from 'react'
import { Button, SearchBox, DialogHeader } from '@checkmarx/cx-ui';
import Dialog from 'material-ui/Dialog';
import classNames from 'classnames';
import PortalDropdown from '../../../portal/portalDropdown';
import AddLdapGroupMappingListContainer from '../../addLdapGroupMappingList';
import styles from './style.scss';

export default class AddLadpGroupMappingDialog extends Component {
    
    render() {
    
        let isSelected = false;
        const buttonText = this.props.selectedEntries > 0 
            ? `${this.props.translations.addGroups} (${this.props.selectedEntries})`
                : `${this.props.translations.addGroups}`

        const actions = [
            <span className='portal-blank-button' onClick={this.props.closeDialog}>
                {this.props.translations.cancel}
            </span>,
            <Button 
                onClick={this.props.importGroups}
                disabled={this.props.selectedEntries === 0}
                text={buttonText}
                inProgress={this.props.importInProgress}
            >
            </Button>
        ];

        const customContentStyle = {
            width: '735px',
            backgroundColor: '#D82D49',
            padding: 0
        };

        return (
            <div>
                <Dialog 
                    className={classNames(styles.ldapAddGroupsHeader)}
                    titleClassName={classNames(styles.ldapAddGroupsDialogTitle)}
                    actionsContainerClassName={classNames(styles.ldapAddGroupsDialogActions, styles.topBorder)}
                    actions={actions}
                    bodyStyle={{
                        height: '485px',
                        padding: 0
                    }}
                    contentStyle={customContentStyle}
                    open={this.props.open}>
                    <div className={classNames(styles.ldapAddGroupsMainWrapper)}>
                        <div className={classNames(styles.ldapAddGroupsBody)}>
                            <DialogHeader
                                title={this.props.translations.addGroups}
                                displayCloseButton
                                closeClick={this.props.closeDialog}
                            />
                            <div>
                                <PortalDropdown
                                    width='335px'
                                    hintText={this.props.translations.directory}
                                    floatingLabelText={this.props.translations.directory}
                                    items={this.props.ldapServers}
                                    onChange={this.props.ldapServersChange}
                                    value={this.props.selectedItem}
                                    helpTooltipText={this.props.translations.selectLdapDirectoryGroupMapping}
                                />
                            </div>
                            <div className={classNames(styles.groupMapSearchboxWrapper)}>
                                <form onSubmit={this.props.search}>
                                    <SearchBox 
                                        onChange={this.props.onChange}
                                        placeHolder={this.props.translations.searchLdapGroups} 
                                        value={this.props.searchValue}
                                    />
                                </form>
                            </div>
                        </div>
                        <div className={classNames(styles.ldapGroupMapDialogContentWrapper)}>
                            <AddLdapGroupMappingListContainer
                                addTeamMember={this.addTeamMember}
                            />
                        </div>
                    </div>
                </Dialog>
            </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/teams/addLdapGroupMappingDialogContainer/addLdapGroupMappingDialog/index.jsx